import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BootupService } from '../services/bootup/bootup.service';
import { PAGE } from 'src/app/routes';

@Injectable({
  providedIn: 'root',
})
export class NoUpdateRequiredGuard {
  private bootupService = inject(BootupService);
  private router = inject(Router);

  public async canActivate(): Promise<boolean> {
    if (await this.bootupService.updateRequired()) {
      return true;
    }
    this.router.navigate([PAGE.LOADING]);
    return false;
  }
}
